var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('div', {
    staticClass: "mb-12 mb-lg-16"
  }, [_c('form-baseinfo-application-toggle', {
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.application,
      callback: function callback($$v) {
        _vm.application = $$v;
      },
      expression: "application"
    }
  })], 1), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-lg-0",
    attrs: {
      "lg": "auto"
    }
  }, [_c('datetime-picker-field', _vm._b({
    attrs: {
      "label": "접수기간(시작)",
      "hideTime": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.application.startsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "startsAt", $$v);
      },
      expression: "application.startsAt"
    }
  }, 'datetime-picker-field', {
    attrs_input: {
      disabled: _vm.disabled,
      dense: true,
      outlined: true,
      hideDetails: true,
      persistentPlaceholder: true,
      class: 'min-w-200px min-w-xl-260px'
    }
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" ~ ")]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('datetime-picker-field', _vm._b({
    attrs: {
      "label": "접수기간(종료)"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.application.endsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "endsAt", $$v);
      },
      expression: "application.endsAt"
    }
  }, 'datetime-picker-field', {
    attrs_input: {
      disabled: _vm.disabled,
      dense: true,
      outlined: true,
      hideDetails: true,
      persistentPlaceholder: true,
      class: 'min-w-200px min-w-xl-260px'
    }
  }, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "채용 시 마감",
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.application.closesOnHiring,
      callback: function callback($$v) {
        _vm.$set(_vm.application, "closesOnHiring", $$v);
      },
      expression: "application.closesOnHiring"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }